import { render, staticRenderFns } from "./ModalPortals.vue?vue&type=template&id=304f25ed"
import script from "./ModalPortals.vue?vue&type=script&lang=js"
export * from "./ModalPortals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports